import { atom } from 'jotai';

export const accountAtom = atom({});
